module.exports = __webpack_public_path__ + "static/media/tab-cae.9e78e2c9.svg";